<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

:root {
  --safe-area-inset-top: var(--safe-top, env(safe-area-inset-top));
  --safe-area-inset-right: var(--safe-right, env(safe-area-inset-right));
  --safe-area-inset-bottom: var(--safe-bottom, env(safe-area-inset-bottom));
  --safe-area-inset-left: var(--safe-left, env(safe-area-inset-left));
}

html,
body {
  font-family: 'Roboto Condensed', sans-serif;
  margin: 0;
  padding: 0;
  min-height: auto !important;
}

html:has(#message-sent),
body:has(#message-sent) {
  overflow: hidden;
  touch-action: none;
  -ms-touch-action: none;
}

#app {
  font-family: 'Roboto Condensed', sans-serif;
}

@media (max-width: 960px) {
  #app {
    min-height: calc(100vh - 48px);
  }
}

@media (max-width: 600px) {
  #app {
    min-height: calc(100vh - 56px);
  }
}

@media screen and (min-width: 760px) {
  #app {
    min-height: calc(100vh - 100px);
  }
}

.md-theme-default :not(input):not(textarea)::selection {
  color: #fff !important;
  background-color: #448aff !important;
}

.md-button::before {
  will-change: unset !important;
}

body {
  background: #fff;
}

// ===
// Base element styles
// ===

// ===
// Vendor
// ===

#nprogress .bar {
  background: #000;
}
</style>
